import { render, staticRenderFns } from "./CreateEditSubcategoriaContaModal.vue?vue&type=template&id=6a0cdf39&"
import script from "./CreateEditSubcategoriaContaModal.vue?vue&type=script&lang=js&"
export * from "./CreateEditSubcategoriaContaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports